/**
 * Load article/page data
 * @param {string} slug - Page slug (city slug or page slug)
 * @param {string} locale - Language code ('de', 'fr', or 'en')
 * @param {string} type - Type of page: 'city' or 'page' (default: auto-detect)
 * @returns {Promise<Object|null>} Article data or null if not found
 */
export const loadArticle = async (slug, locale = 'de', type = null) => {
  // Auto-detect type: check if it's a city by trying cities first
  if (!type) {
    try {
      // Cities are saved directly in cities directory (no language subdirectory)
      const cityArticle = await import(`../data/cities/${slug}.json`)
      return cityArticle.default || cityArticle
    } catch (cityError) {
      // Not a city, try regular pages
      type = 'page'
    }
  }
  
  try {
    if (type === 'city') {
      // Load from cities directory (no language subdirectory)
      const article = await import(`../data/cities/${slug}.json`)
      return article.default || article
    } else {
      // Load from pages directory (segment/global hub pages) - single folder, no language subdirs
      try {
        const article = await import(`../data/pages/${slug}.json`)
        return article.default || article
      } catch (pageError) {
        console.log(`Page not found for ${slug} (pages directory may not exist yet)`)
        return null
      }
    }
  } catch (error) {
    // Article not found
    console.log(`Article not found for ${slug} in ${locale} (type: ${type || 'auto'})`)
    return null
  }
}

